// @ts-nocheck
import { LinkProps } from "@insite/mobius/Link";
import useStructuredData from "@toolkit/Framework/Common/Hooks/useStructuredData";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import { FC, useEffect, useState } from "react";
import { BreadcrumbList, ListItem } from "schema-dts";

/* ---------------------------------------------------------------------------------------------------- */
// https://developers.google.com/search/docs/appearance/structured-data/breadcrumb
/* ---------------------------------------------------------------------------------------------------- */

export interface BreadcrumbStructuredDataProps {
    links: LinkProps[] | undefined;
}

const BreadcrumbStructuredData: FC<BreadcrumbStructuredDataProps> = ({ links }) => {
    const [structuredData, setStructuredData] = useState<Exclude<BreadcrumbList, string>>();

    const {
        extensionWebsiteSettings: { enableStructuredData, enableStructuredDataBreadcrumb },
    } = useSettingsCollection();

    useEffect(() => {
        if (
            !enableStructuredData ||
            !enableStructuredDataBreadcrumb ||
            !links?.length ||
            typeof window === "undefined"
        ) {
            return;
        }

        setStructuredData({
            "@type": "BreadcrumbList",
            itemListOrder: "ItemListOrderAscending",
            itemListElement: links.map(
                (link, index): ListItem => ({
                    "@type": "ListItem",
                    position: index + 1,
                    item: {
                        "@id": link.href ? window.location.origin + link.href : window.location.href,
                        name: link.children?.toString(),
                    },
                }),
            ),
            numberOfItems: links.length,
        });
    }, [links]);

    useStructuredData(structuredData);

    return null;
};

export default BreadcrumbStructuredData;
